import { InjectionToken } from '@angular/core';
import { MenuItem } from '../domain/menuItem.model';

export const PROFILE_MENU_ITEMS = new InjectionToken<MenuItem[]>('PROFILE_MENU_ITEMS', {
  factory: () => [],
});
